import React, { useState } from "react";
import { Route } from "react-router-dom";
import { getRandom } from "../util/General";

const Pages = props => {
    const [rnd, setRnd] = useState(getRandom());

    return (
        <div className="wrapper wrapper-full-page">
            <div className="full-page row w-100 row login-page no-gutters">
                <Route path={props.path} exact={!!props.exact} component={props.component} />
                {!props.hideBg && (
                    <div className="full-page-background" style={{ backgroundImage: `url(/img/bg/${rnd}.jpg)` }} />
                )}
            </div>
        </div>
    );
};

export default Pages;
